// extracted by mini-css-extract-plugin
export default {"cvvButton":"P88pp","cvvResendText":"wpEo1","container":"_2oMcU","skeleton-progress":"RDZjf"};